import templateUrl from './default-filters-info.tpl.html';

class DefaultFiltersInfoController {
	static $inject = ['MassiaAuthService', '$scope', '$rootScope'];

	constructor(MassiaAuthService, $scope, $rootScope) {
		this.MassiaAuthService = MassiaAuthService;
		this.$scope = $scope;
		this.$rootScope = $rootScope;
	}

	$onInit() {
		this._update(this._read(), this.$rootScope._autoFilterRegistry);

		this.$scope.$on('massiaDefaultFiltersChanged', (_event, data) => this._update(data, this.$rootScope._autoFilterRegistry));
		this.$scope.$on('massiaAutoFilterRegistryChanged', (_event, registry) => this._update(this._read(), registry));
	}

	_read() {
		const user = this.MassiaAuthService.getAuthenticatedUser();
		if (!user) return null;
		const userId = user.id || user.userId || user.login;
		try {
			const raw = localStorage.getItem(`massia_default_filters_${userId}`);
			return raw ? JSON.parse(raw) : null;
		} catch (e) {
			return null;
		}
	}

	_update(data, registry) {
		this.hasDefaultFilter = !!(data && data.idSociete && data.idSociete != 0);
		this.pageHasAutoSociete = !!(registry && registry.idSociete > 0);
		this.pageHasAutoSite = !!(registry && registry.idSite > 0);
	}
}

export default {
	bindings: {},
	template: templateUrl,
	controller: DefaultFiltersInfoController
};
